import { __awaiter, __extends, __generator } from "tslib";
import Model from './model';
import { getUtcTimestamp } from '../utils';
var Message = (function (_super) {
    __extends(Message, _super);
    function Message() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Message.prototype.markAsRead = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.readAt) {
                            return [2];
                        }
                        return [4, this.client.http.post("/messages/" + this.id + "/mark-as-read")];
                    case 1:
                        _a.sent();
                        this.readAt = getUtcTimestamp();
                        return [2];
                }
            });
        });
    };
    return Message;
}(Model));
export default Message;
var DefaultMessage = (function (_super) {
    __extends(DefaultMessage, _super);
    function DefaultMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DefaultMessage;
}(Message));
export { DefaultMessage };
var EducationMessage = (function (_super) {
    __extends(EducationMessage, _super);
    function EducationMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EducationMessage;
}(Message));
export { EducationMessage };
var PhotoUploadMessage = (function (_super) {
    __extends(PhotoUploadMessage, _super);
    function PhotoUploadMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PhotoUploadMessage;
}(Message));
export { PhotoUploadMessage };
var RetakePhotoMessage = (function (_super) {
    __extends(RetakePhotoMessage, _super);
    function RetakePhotoMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RetakePhotoMessage;
}(DefaultMessage));
export { RetakePhotoMessage };
var RequestPhotoMessage = (function (_super) {
    __extends(RequestPhotoMessage, _super);
    function RequestPhotoMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RequestPhotoMessage;
}(DefaultMessage));
export { RequestPhotoMessage };
//# sourceMappingURL=message.js.map